import React from 'react'
import { Divider, ListItem, ListItemIcon, ListItemText, Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import List from '@mui/material/List'
import PeopleIcon from '@mui/icons-material/People'
import { useAuth } from '../../../../../../context/Auth'
import { useNavigate } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dividerFullWidth: {
      margin: `5px 0 0 ${theme.spacing(2)}`,
    },
  })
)

export const AdminDrawerList = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const handleUsers = () => {
    navigate('/users')
  }
  const classes = useStyles()

  if (auth && auth.admin) {
    return (
      <List>
        <Divider component="li" />
        <li>
          <Typography
            className={classes.dividerFullWidth}
            color="textSecondary"
            display="block"
            variant="caption"
          >
            Administracja
          </Typography>
        </li>
        <ListItem button onClick={handleUsers}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary={'Użytkownicy'} />
        </ListItem>
      </List>
    )
  }

  return <></>
}
